/* eslint-disable import/prefer-default-export */
const groupItems = (resources, totalBalance) => {
  const itemGroupMap = resources.reduce((acc, curr) => { // eslint-disable-line
    const categoryName = curr.attr('category');
    const categoryPrompt = curr.selectedOptions('category', 'prompt')[0];

    if (!acc[categoryName]) {
      acc[categoryName] = {
        name: categoryPrompt,
        category: curr.attr('category'),
        sum: 0,
        items: [],
      };
    }

    acc[categoryName].sum += parseFloat(curr.attr('balance'));
    acc[categoryName].items.push({
      accountId: curr.attr('accountId'),
      balance: curr.attr('balance'),
      category: curr.attr('category'),
      name: curr.attr('name'),
      syncStatus: curr.attr('syncStatus'),
      id: curr.relationship('source')?.link('related')?.param('id'),
      resource: curr,
    });

    return acc;
  }, {});

  const itemGroups = Object.values(itemGroupMap);
  const totalBalanceInt = parseInt(totalBalance, 10);

  return itemGroups.map((itemGroup) => {
    const percentOfTotal = totalBalanceInt !== 0 ? parseInt(itemGroup.sum, 10) / totalBalanceInt : 0;

    return {
      ...itemGroup,
      percentOfTotal,
      barName: `${itemGroup.name} ${Math.round(percentOfTotal * 100)}%`,
    };
  });
};

export const convertBalanceSheetCollectionToItems = (balanceSheetCollection) => {
  if (!balanceSheetCollection) {
    return null;
  }
  const [balanceSheetResource] = balanceSheetCollection;
  if (!balanceSheetResource) {
    return null;
  }

  const assets = balanceSheetResource.attr('assets')?.resources().list() || [];
  const assetBalance = balanceSheetResource.attr('totalAssetBalance');

  const liabilities = balanceSheetResource.attr('liabilities')?.resources().list() || [];
  const liabilityBalance = balanceSheetResource.attr('totalLiabilityBalance');

  return {
    assets: {
      items: groupItems(assets, assetBalance),
      totalBalance: assetBalance,
    },
    liabilities: {
      items: groupItems(liabilities, liabilityBalance),
      totalBalance: liabilityBalance,
    },
  };
};
